// extracted by mini-css-extract-plugin
export default {"caloriesIconWrapper":"caloriesIconWrapper___b6Ujz","nutritionSummary":"nutritionSummary___XmSLG","nutritionSummaryLarge":"nutritionSummaryLarge___SG0tY"};